import { PricingSheetRow } from "../types";

/**
 * Row contains rental history on prcicing basis DAY
 */
export const isRentalHistoryRowDay = (pricingSheetRow: PricingSheetRow) =>
  Boolean(pricingSheetRow.rentalDaysDay && pricingSheetRow.rentalDaysDay > 0);
